var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 23,
    viewBox: "0 0 32 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6812 4.85625C31.6812 4.85625 31.3688 2.65 30.4062 1.68125C29.1875 0.40625 27.825 0.4 27.2 0.325C22.725 -1.78814e-07 16.0063 0 16.0063 0H15.9937C15.9937 0 9.275 -1.78814e-07 4.8 0.325C4.175 0.4 2.8125 0.40625 1.59375 1.68125C0.63125 2.65 0.325 4.85625 0.325 4.85625C0.325 4.85625 0 7.45 0 10.0375V12.4625C0 15.05 0.31875 17.6437 0.31875 17.6437C0.31875 17.6437 0.63125 19.85 1.5875 20.8188C2.80625 22.0938 4.40625 22.05 5.11875 22.1875C7.68125 22.4312 16 22.5063 16 22.5063C16 22.5063 22.725 22.4937 27.2 22.175C27.825 22.1 29.1875 22.0938 30.4062 20.8188C31.3688 19.85 31.6812 17.6437 31.6812 17.6437C31.6812 17.6437 32 15.0562 32 12.4625V10.0375C32 7.45 31.6812 4.85625 31.6812 4.85625ZM12.6938 15.4062V6.4125L21.3375 10.925L12.6938 15.4062Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.6027a3b95f29806e39e05242d907ab39.svg";
export { ForwardRef as ReactComponent };